import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "affiliate-navigation-bar-mobile" }
const _hoisted_2 = { class: "affiliate-navigation-bar-mobile__top" }
const _hoisted_3 = { class: "affiliate-navigation-bar-mobile__logos-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "affiliate-navigation-bar-mobile__affiliate-logo-wrapper"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "affiliate-navigation-bar-mobile__bottom"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "affiliate-navigation-bar-mobile__tab-circle" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "affiliate-navigation-bar-mobile__tab-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          alt: "abaca logo",
          class: "affiliate-navigation-bar-mobile__abaca-logo",
          src: "/img/logos/abaca-logo--white.svg"
        }, null, -1)),
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.logo,
                alt: "Affiliate Logo",
                class: "affiliate-navigation-bar-mobile__affiliate-logo",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogoClick && _ctx.onLogoClick(...args)))
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showSteps && _ctx.steps.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `affiliate-navigation-bar-mobile:${index}`,
              class: _normalizeClass([{
          'affiliate-navigation-bar-mobile__tab--active': step.id === _ctx.activeStep,
          'affiliate-navigation-bar-mobile__tab--completed': step.id < _ctx.activeStep,
          'affiliate-navigation-bar-mobile__tab--disabled': _ctx.disabled,
        }, "affiliate-navigation-bar-mobile__tab"]),
              onClick: ($event: any) => (_ctx.onStepClick(step.id))
            }, [
              _createElementVNode("div", _hoisted_8, [
                (step.id < _ctx.activeStep)
                  ? (_openBlock(), _createBlock(_component_PxIcon, {
                      key: 0,
                      name: "check--white",
                      size: 12
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(index + 1), 1))
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(step.title)), 1)
            ], 10, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}